<!-- eslint-disable vue/no-v-html -->
<template>
  <SuccessAlert
    v-if="chosenBook && bookDownloadable"
    class="d-flex justify-content-md-center"
  >
    <span class="fw-semibold">
      {{ $label('subscription.basic.chosenBookAlert.title') }}&nbsp;
    </span>
    <span class="d-block d-md-inline-block mt-8 mt-md-0">
      {{ $label('subscription.basic.chosenBookAlert.text') }}
    </span>
  </SuccessAlert>

  <InfoAlert v-else-if="message" class="d-md-flex justify-content-center">
    <span v-html="message" />
  </InfoAlert>

  <NotAvailableAlert
    v-else-if="bookFromOlderSelections"
    :logged-in-user="loggedInUser"
    :category-code="categoryCode"
  />

  <div v-else></div>
</template>

<script>
import InfoAlert from '~/components/alerts/InfoAlert'
import SuccessAlert from '~/components/alerts/SuccessAlert'
import NotAvailableAlert from '~/components/monthlyBooks/NotAvailableAlert'
import { useBook } from '~/composables/useBook'

export default {
  components: {
    InfoAlert,
    SuccessAlert,
    NotAvailableAlert,
  },
  props: {
    book: {
      type: Object,
      required: true,
    },
    bookDownloadable: {
      type: Boolean,
      default: false,
    },
    chosenBook: {
      type: Boolean,
      default: false,
    },
    loggedInUser: {
      type: [Object, Boolean],
      default: false,
    },
  },
  setup() {
    const { isNextMonth, isCurrentMonth, isPrevMonth, isOlderThanPrevMonth } =
      useBook()

    return {
      isNextMonth,
      isCurrentMonth,
      isPrevMonth,
      isOlderThanPrevMonth,
    }
  },
  computed: {
    message() {
      if (this.isNextMonth(this.categoryCode)) {
        return this.$label('books.downloadAlert.nextMonthBook')
      }

      if (this.bookDownloadable && this.isCurrentMonth(this.categoryCode)) {
        return this.$label('books.downloadAlert.currentMonthBook')
      }

      if (this.bookDownloadable && this.isPrevMonth(this.categoryCode)) {
        return this.$label('books.downloadAlert.prevMonthBook')
      }

      return ''
    },
    isRightSubscription() {
      return (
        this.book.download &&
        this.book.download.ebook.downloadAvailableForUserSubscription
      )
    },
    categoryCode() {
      return this.book.categoryCode
    },
    bookFromOlderSelections() {
      return (
        (!this.bookDownloadable && this.isPrevMonth(this.categoryCode)) ||
        this.isOlderThanPrevMonth(this.categoryCode)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.alert {
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 2px;

  :deep(.container) {
    justify-content: center;
  }
}
</style>
